// --- Dependencies
import React from 'react';
// --- Styles
import styles from './layout-one-row.module.scss';

/**
 * OneRowLayout Component
 *
 * This functional component acts as a layout wrapper that organizes its children into a single row.
 * It applies styles from `styles.container` to ensure proper structure and appearance.
 *
 * @component
 * @param {Object} props - Component properties.
 * @param {React.ReactNode} props.children - Elements to be wrapped inside the one-row layout.
 * @returns {JSX.Element} A styled section containing child components.
 */
const OneRowLayout = ({ children }) => <section className={styles.container}>{children}</section>;

export default OneRowLayout;